"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.MediaMediaTypeEnum = exports.StateCode = void 0;
var StateCode;
(function (StateCode) {
    StateCode["Enabled"] = "enabled";
    StateCode["Disabled"] = "disabled";
})(StateCode = exports.StateCode || (exports.StateCode = {}));
var MediaMediaTypeEnum;
(function (MediaMediaTypeEnum) {
    MediaMediaTypeEnum["Audio"] = "audio";
    MediaMediaTypeEnum["Image"] = "image";
    MediaMediaTypeEnum["Pdf"] = "pdf";
    MediaMediaTypeEnum["Video"] = "video";
    MediaMediaTypeEnum["Youtube"] = "youtube";
})(MediaMediaTypeEnum = exports.MediaMediaTypeEnum || (exports.MediaMediaTypeEnum = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["PwdFormatError"] = "pwd_format_error";
    ErrorCode["PwdMatchError"] = "pwd_match_error";
    ErrorCode["PwdReuseError"] = "pwd_reuse_error";
    ErrorCode["UsernameFormatError"] = "username_format_error";
    ErrorCode["UsernameUnicityError"] = "username_unicity_error";
    ErrorCode["EmailFormatError"] = "email_format_error";
    ErrorCode["GenderCodeError"] = "gender_code_error";
    ErrorCode["PhoneFormatError"] = "phone_format_error";
    ErrorCode["PreferenceFormatError"] = "preference_format_error";
    ErrorCode["LocationFormatError"] = "location_format_error";
    ErrorCode["AlertFormatError"] = "alert_format_error";
    ErrorCode["MemberFormatError"] = "member_format_error";
    ErrorCode["MemberInviteError"] = "member_invite_error";
    ErrorCode["TosAgreementError"] = "tos_agreement_error";
    ErrorCode["AccountAlreadyActivatedError"] = "account_already_activated_error";
    ErrorCode["ResourceNotFound"] = "resource_not_found";
    ErrorCode["InvalidJsonError"] = "invalid_json_error";
    ErrorCode["InvalidRegionCode"] = "invalid_region_code";
    ErrorCode["FullTeamError"] = "full_team_error";
    ErrorCode["UnidentifiedError"] = "unidentified_error";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
